// extracted by mini-css-extract-plugin
export default {"container":"_2Il_aSBb9w_jE2rAoEpqdv"};